export const environment = {
  //SSO APIs
  SSOauthAPI: "https://dapi.auth.myzpax.com/api",
  ssoUserInfoAPI: "https://dapi.auth.myzpax.com/connect/userinfo",
  ssoConnectAPI: "https://dapi.auth.myzpax.com/connect/authorize",
  ssoLogoutAPI: "https://dapi.auth.myzpax.com/api/account/logout",
  ssoLoginUrl: "https://dev.auth.myzpax.com/sso/login",

  zpaxEsignatureDocumentRedirectEndPoint: "https://dev.myzpax.com/app/document-signature/documents",
  zpaxChangepasswordEndpoint:"https://dev.myzpax.com/user/password-and-security",
  zpaxPrivacyPolicyEndPoint: "https://dev.myzpax.com/privacy.html",
  zpaxTermsEndPoint: "https://dev.myzpax.com/terms.html",

  endpoint: "https://dapi.zrehabconnect.com/api/v1",
  sessionEncryptionKey:
    "fCCmUMuOM0kuDCuLe7naPOo6sNvlhXshFhZEVomw5XAS9vR7M0YGxbeaeYhiNmOC",
  idleTimeBeforeLocking: 1800,
  idleTimeBeforeTerminating: 2400,
  clientId: "rehab-connect",
  userDetailsAPI: "/user/get",
  authorizationAPI: "/authorization",
  AWS_REGION: "us-east-1",
  AWS_ACCESS_KEY_ID: "",
  AWS_SECRET_ACCESS_KEY: "",
  AWS_SESSION_TOKEN: "",
  biDashboardSupersetDomain : 'https://4df6a8e3.us2a.app.preset.io',

  /**Matomo Analytics*/
  enableMatomo: false,
  matomo: {
    trackerUrl: "https://sandbox.matomo.z-pax.com/",
    siteId: 4
  },

  /**Pagesense */
  enablePagesense: false,
  pagesenseUrl: "https://cdn.pagesense.io/js/rehabconnectllc/b4f58c20f6384385a840cbf314bb6653.js",

  growthbook: {
    apiHost: "https://api.rc-feature-flag-dev-qa.zrehabconnect.com",
    clientKey: "sdk-0qGw9UIJ4xGVWKGi",
    enableDevMode: true
  },
    
  /**Sumo Logic RUM */
  enableSumoRum: true,
  sumoRum: {
    collectionSourceUrl: 'https://rum-collectors.us1.sumologic.com/receiver/v1/rum/ZaVnC4dhaV05A-R_JYkK1_ivbivT3fBaKjOPdEVQyA_HYR0rzdM7JJMciX2P3-rqNyp8m_qvORWQFL9WJJEnl9Byxv2qJWxoZavrBMxpKhK4FyCbzaEljA==',
    serviceName: 'rc-dev-frontend',
    applicationName: 'rehabconnect-dev',
    deploymentEnvironment: 'dev',
    propagateTraceHeaderCorsUrls: [
        /^https:\/\/dapi\.zrehabconnect\.com\/.*/,
        /^https:\/\/dapi\.auth\.myzpax\.com\/.*/,
      ],
    ignoreUrls: [
      /^https:\/\/cdn\.pagesense\.io\/.*/,
      /^https:\/\/sandbox\.matomo\.z-pax\.com\/.*/,
      /^https:\/\/4df6a8e3\.us2a\.app\.preset\.io\/.*/,
      /^https:\/\/api\.rc-feature-flag.*\.zrehabconnect\.com\/.*/,
    ],
  }
};
